import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getModulesDropdownList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.MODULES_DROPDOWN_LIST.METHOD](APIConfig.MODULES_DROPDOWN_LIST.URL, payload);
}

const getFeaturesData = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_MODULE_FEATURE_DATA.METHOD](APIConfig.GET_MODULE_FEATURE_DATA.URL, payload);
}
const addModuleFeatureData = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_MODULE_FEATURE_DATA.METHOD](APIConfig.ADD_MODULE_FEATURE_DATA.URL, payload);
}
const deleteModuleFeatureData = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_MODULE_FEATURE_DATA.METHOD](APIConfig.DELETE_MODULE_FEATURE_DATA.URL, payload);
}
const SystemSettingsService = {
    getModulesDropdownList,
    getFeaturesData,
    addModuleFeatureData,
    deleteModuleFeatureData
}
export default SystemSettingsService;